;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"41ff2190ab3664f48686f8a31054a0b2ea1017a1"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.14";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale/auth\",\"regex\":\"^/([^/]+)/auth$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/setup\",\"regex\":\"^/([^/]+)/setup$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/courses\",\"regex\":\"^/([^/]+)/courses$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/courses/:id\",\"regex\":\"^/([^/]+)/courses/([^/]+)$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/deadlines\",\"regex\":\"^/([^/]+)/deadlines$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/digest\",\"regex\":\"^/([^/]+)/digest$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/predict\",\"regex\":\"^/([^/]+)/predict$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/settings\",\"regex\":\"^/([^/]+)/settings$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/timetable\",\"regex\":\"^/([^/]+)/timetable$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[{\"path\":\"/\"}],\"isrRoutes\":[]}";import * as Sentry from "@sentry/nextjs";

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const gitSha = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA;

if (dsn) {
  Sentry.init({
    dsn,
    tunnel: "/api/sentry-tunnel",
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV,
    sendDefaultPii: false,
    release: gitSha ? `uniboard-web@${gitSha.slice(0, 8)}` : undefined,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
    ],
    beforeSend(event) {
      const message = event.exception?.values?.[0]?.value ?? "";
      if (/ChunkLoadError|Loading chunk/.test(message)) return null;
      if (/Failed to fetch|NetworkError|Load failed/.test(message))
        return null;
      return event;
    },
  });
}

// Instrument App Router navigations
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
